export const onRouteUpdate = ({ location }) => {
  if (typeof window === "undefined") return

  const params = new URLSearchParams(location.search)
  const keys = ["utm_source", "utm_medium", "utm_campaign", "utm_content"]
  const current = {}

  keys.forEach(key => {
    const value = params.get(key)
    if (value) current[key] = value
  })

  if (Object.keys(current).length) {
    sessionStorage.setItem("gwp_attribution", JSON.stringify(current))
  }
}
